import * as React from "react";
import styled from "styled-components";
import { PersonSubActivityJudgeSearchPanel } from "./PersonSubActivityJudgeSearchPanel";
import {
  PersonSubActivityJudgeSavePanel,
  IPersonSubActivityJudgeSavePanelProps,
} from "./PersonSubActivityJudgeSavePanel";
import { PanelStack, Classes, IPanel } from "@blueprintjs/core";
import { ETLCodes } from "../../../../../locales";
import { useTl } from "../../../../../hooks";
import { SubActivityGridDto } from "../../../../../api";

export interface IPersonSubActivityJudgePanelStackProps extends Pick<IPersonSubActivityJudgeSavePanelProps, "onSaved"> {
  personId: number;
}

const Container = styled.div`
  flex: 1;
  height: 100%;
  & > .${Classes.PANEL_STACK} {
    height: 100%;
  }
`;

export const PersonSubActivityJudgePanelStack: React.FunctionComponent<IPersonSubActivityJudgePanelStackProps> = ({
  personId,
  onSaved,
}) => {
  const { t } = useTl();
  const onSectionSelected = React.useCallback(
    (data: SubActivityGridDto) => {
      setPanelStack((currentStack) => [
        ...currentStack,
        {
          component: () => (
            <PersonSubActivityJudgeSavePanel
  onSaved={onSaved}
  subActivity={data}
  personId={personId}
  />
          ),
        },
      ]);
    },
    [onSaved, personId]
  );

  const [panelStack, setPanelStack] = React.useState<IPanel[]>([
    {
      component: () => (
        <PersonSubActivityJudgeSearchPanel
  onSubActivitySelected={onSectionSelected}
  personId={personId}
  />
      ),
      title: t(ETLCodes.SubActivitySelection),
    },
  ]);

  const removeFromPanelStack = React.useCallback(() => {
    setPanelStack((prev) => prev.slice(0, prev.length - 1));
  }, [setPanelStack]);

  return (
    <Container>
      <PanelStack stack={panelStack} showPanelHeader={true} onClose={removeFromPanelStack}/>
    </Container>
  );
};
